import { Box, BoxProps, Divider, Icon, Paragraph, Stack } from '@ui'

type Props = {
    features: string[] | null
    spaceId: string | undefined
} & BoxProps
export const TownFeaturesWithPrice = (props: Props) => {
    const { features, children, ...boxProps } = props

    return (
        <Box
            rounded
            gap="md"
            padding={{ default: 'lg', touch: 'md' }}
            background="level2"
            {...boxProps}
        >
            {features?.length ? <TownFeatures features={features} /> : null}

            {children}
        </Box>
    )
}

export const TownFeatures = (props: { features: string[]; withDivider?: boolean }) => {
    const { features, withDivider: addDivider } = props

    return features?.length ? (
        <>
            {addDivider && <Divider />}
            <Paragraph strong size="lg">
                What You Get
            </Paragraph>
            <Stack gap="x2">
                {features?.map((feature) => (
                    <Stack horizontal key={feature} gap="sm">
                        <Box centerContent square="square_xs" background="positive" rounded="sm">
                            <Icon type="check" size="square_xs" />
                        </Box>
                        <Box paddingTop="xxs">
                            <Paragraph>{feature}</Paragraph>
                        </Box>
                    </Stack>
                ))}
            </Stack>
        </>
    ) : null
}
